import { Directive, Optional, Host, Self, Injectable } from '@angular/core';
import {
  CellClickEvent,
  CellComponent,
  FilterService,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { Subject } from 'rxjs';
import { GridRightClickMenuComponent } from './grid-right-click-menu.component';

/**
 * A service that coordinates between the grid component, directive, and context menu.
 * 
 * This service maintains references to the grid, filter service, and menu component,
 * facilitating communication between these components when users interact with the
 * right-click context menu. It acts as a central coordination point for the grid
 * right-click menu functionality.
 * 
 * @example
 * ```typescript
 * // Service is automatically provided at the root level
 * constructor(private menuService: GridRightClickMenuService) {
 *   // Access menu service properties
 * }
 * ```
 */
@Injectable({
  providedIn: 'root',
})
export class GridRightClickMenuService {
  /**
   * Creates an instance of GridRightClickMenuService.
   */
  constructor() {
    console.log('GridRightClickMenuService');
  }
  /**
   * Reference to the context menu component.
   */
  menu?: GridRightClickMenuComponent;
  /**
   * Reference to the grid component where the context menu was triggered.
   */
  grid?: GridComponent;
  /**
   * Reference to the Kendo filter service for applying filters to the grid.
   */
  filterService?: FilterService;
  /**
   * The cell click event that triggered the context menu.
   */
  event?: CellClickEvent;
}
